<template>
  <div class="auth">
    <div class="header" v-if="heading">
      <h4 class="normal">{{ heading }}</h4>
    </div>
    <el-alert v-if="errors.message" :title="errors.message" type="error" :closable="false"></el-alert>
    <component :is="comp"></component>    
  </div>
</template>
<script>
export default {
  computed: {
    comp() {
      return this.$store.state.auth.component;
    },
    heading() {
      return this.$store.getters['auth/getHeading'];
      //return this.$store.state.auth.heading;
    },
    errors() {
      return this.$store.state.auth.errors;
    },
    message() {
      return this.$store.getters['auth/getMessage'];
    },
  }
}
</script>
<style>
.el-alert {
  margin-top: -10px;
  margin-bottom: 20px;
}

.auth .el-button {
  width: 100%;
}
</style>
